const steeringCommittee = [
        
        {
            category: "General Chair(s)",
            members: [
                {
                    name: "Prof. Aboul Ella Hassanien",
                    affiliation: "Kuwait University, Kuwait"
                },
                {
                    name: "Prof. Nguyen Gia Nhu",
                    affiliation: "Duy Tan University, Vietnam"
                }
            ]
        },
        {
            category: "Honorary Chair(s)",
            members: [
                {
                    name: "Dr. Bao Le Nguyen",
                    affiliation: "Duy Tan University, Vietnam"
                },
                {
                    name: "Prof. Manu Malek",
                    affiliation: "EiC Computer and Electrical Engineering, Stevens Institute of Technology, USA"
                },
                {
                    name: "Jon G. Hall",
                    affiliation: "EiC Expert Systems (WILEY), The Open University, UK"
                }
            ]
        },
        {
            category: "Conference Chair(s)",
            members: [
                {
                    name: "Prof. Rajesh Ingle",
                    affiliation: "Vice-Chancellor, Symbiosis Skills and Professional University, India"
                },
                {
                    name: "Dr. Dang Viet Hung",
                    affiliation: "Duy Tan University, Vietnam"
                },
               
                {
                    name: "Prof. Ahmed Taher Azar",
                    affiliation: "Prince Sultan University, Saudi Arabia"
                },
                {
                    name: "Prof. Projesh Roy",
                    affiliation: "Joint Director, Campus of Open Learning, University of Delhi, India"
                }
            ]
        },
        {
            category: "Technical Program Chair(s)",
            members: [                
                {
                    name: "Prof. Ta Minh Thanh",
                    affiliation: "Le Quy Don University, Vietnam"
                },
                {
                    name: "Dr. Imad Riza",
                    affiliation: "University of Applied Sciences for Technology Compiegne, France"
                },
                // {
                //     name: "Dr. Anand Nayyar",
                //     affiliation: "Duy Tan University, Vietnam"
                // },
                // {
                //     name: "Prof. Lalit Garg",
                //     affiliation: "University of Malta, Malta"
                // }
            ]
        },
        {
            category: "Publication Chair(s)",
            members: [                
                {
                    name: "Dr. Utku Kose",
                    affiliation: "Suleyman Demirel University, Isparta, Turkey"
                }
            ]
        },
        {
            category: "Publicity Chair(s)",
            members: [
                {
                    name: "Dr. Jafar A. Alzubi",
                    affiliation: "Al-Balqa Applied University, Salt Jordan"
                },
                {
                    name: "Dr. M. Tanveer",
                    affiliation: "Indian Institute of Technology, Indore"
                }                
            ]
        },
        {
            category: "Organizing Chair(s)",
            members: [
                {
                    name: "Dr. Suresh Chavan",
                    affiliation: "IIIT Raichur, India"
                },
                {
                    name: "Dr. Le Van Chung",
                    affiliation: "Duy Tan University, Vietnam"
                },
                {
                    name:"Deepak Gupta",
                    affiliation:"Maharaja Agrasen Institute of Technology, India"
                }
            ]
        },
        {
            category: "Convener(s)",
            members: [
                {
                    name: "Prof. Ajay Jaiswal",
                    affiliation: "Principal, School of Open Learning, University of Delhi, India"
                },
                {
                    name: "Dr. Aditya Khamparia",
                    affiliation: "Babasaheb Bhimrao Ambedkar University, Lucknow, India"
                }
            ]
        },
        {
            category: "Co-Convener(s)",
            members: [
                {
                    name: "Dharmateja Priyadarshi Uddandarao",
                    affiliation: "Amazon, USA"
                },
{
                    name: "Uday Kumar Reddy GANGULA",
                    affiliation: "Software Engineering MTS, Salesforce Inc."
                },
                {
                    name: "Janardhana Naidu Kola",
                    affiliation: "Director of Business Intelligence, ADP (Automatic Data Processing, Inc.), USA"
                },
                 {
                    name: "Dr. Yogadhar Pandey",
                    affiliation: "Babasaheb  Bhimrao Ambedkar University, Lucknow, India"
                },
                 {
                    name: "Sangeeth Kumar Vanam",
                    affiliation: "PWC, USA"
                },
                 {
                    name: "Srinivas Nune",
                    affiliation: "Dell Technologies, USA"
                }
            ]
        }
    ];

export default steeringCommittee;